import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';

import { ENV_CONFIG } from 'src/bin/env.config';
import { ErrorHandlerService } from './error-handler.service';
import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { ProductCategory } from 'src/app/models';
import { SalonmonsterHttpClient } from '../services/salonmonster-http-client';
import { UserService } from '../services/user.service';
import { map } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductCategoryService extends SalonmonsterHttpClient {
  constructor(
    http: HttpClient,
    userService: UserService,
    protected errorHandlerService: ErrorHandlerService
  ) {
    super(http, userService, errorHandlerService);
  }

  public loadProductCategoryByID(
    productCategoryID: number
  ): Observable<ProductCategory> {
    const url = `${ENV_CONFIG.API_ROOT}/productcategories/${productCategoryID}`;
    return this.get(url).pipe(
      map((data) => {
        if (data && data.length === 1) {
          return ProductCategory.parse(data[0]);
        } else {
          throwError(new Error('Invalid Product category'));
        }
      })
    );
  }

  public loadProductCategories(): Observable<List<ProductCategory>> {
    const url = `${ENV_CONFIG.API_ROOT}/productcategories`;

    return this.get(url).pipe(
      map((data) => {
        let productCategories: List<ProductCategory> = List([]);

        for (const productData of data) {
          productCategories = productCategories.push(
            ProductCategory.parse(productData)
          );
        }

        return productCategories;
      })
    );
  }

  public save(productCategory: ProductCategory): Observable<ProductCategory> {
    let url = `${ENV_CONFIG.API_ROOT}/productcategories`;
    url +=
      productCategory.getID() !== undefined
        ? '/' + productCategory.getID()
        : '';

    if (productCategory.getID() !== undefined) {
      // update
      return this.put(url, productCategory.serialize()).pipe(
        map((data) => {
          return ProductCategory.parse(data);
        })
      );
    } else {
      // create
      return this.post(url, productCategory.serialize()).pipe(
        map((data) => {
          return ProductCategory.parse(data);
        })
      );
    }
  }

  public deleteProductCategory(
    productCategory: ProductCategory
  ): Observable<ProductCategory> {
    const url = `${ENV_CONFIG.API_ROOT}/productcategories/${productCategory.id}`;

    return this.delete(url, {});
  }
}
